import * as React from "react";
import * as cls from "./ToggleButtonGroup.module.scss";
export { ToggleButtonGroup };
/**
 * Радиокнопки стилизованные под обычные кнопки.
 * 
 * @param {Object} props - Атрибуты элемента.
 * @param {string} [props.id] - Идентификатор поля.
 * Задаёт атрибуты `name` и `id`.
 * @param {string} [props.className] - Дополнительные классы CSS.
 * @param {boolean} [props.uncontrolled] - Неуправляемый компонент.
 * @param {Object|Array} props.dictionary - 
 * Словарь {надпись: значение} или массив значений.
 * @param {string} [props.value] - Значение.
 * @param {EventListener} [props.onChange] - Событие при изменении.
 * @returns {JSX.Element} Элемент JSX.
 * @see {@link ../frame/EventListener.js}
 * @author Алексей Васьковский <avaskovskiy@umney.ru>
 */
function ToggleButtonGroup(
  {
    id,
    className,
    uncontrolled,
    dictionary,
    value,
    onChange
  }) {
  let fullClassName = cls.toggle_button_group;
  if (className) fullClassName += " " + className;
  const pills = [];
  if (Array.isArray(dictionary))
    dictionary = Object.fromEntries(dictionary.map(value => [value, value]));
  for (const option_label in dictionary) {
    const option_value = dictionary[option_label];
    const option_id = id + "-" + option_value;
    pills.push(
      <div className={cls.toggle_button} key={option_id}>
        <input
          type="radio"
          key={option_id}
          id={option_id}
          name={id}
          value={option_value}
          checked={uncontrolled ? undefined : option_value == value}
          onChange={onChange}
          autoComplete="off"
        />
        <label htmlFor={option_id}>{option_label}</label>
      </div>
    );
  }
  return <div className={fullClassName}>{pills}</div>;
}
